function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useMemo } from "react";
import { useQuery, useQueryClient } from "react-query";
export var useUpdateableQuery = function(queryKey, queryFn, options) {
    var queryClient = useQueryClient();
    var query = useQuery(queryKey, queryFn, options);
    return useMemo(function() {
        return _objectSpread({}, query, {
            update: function(data) {
                queryClient.setQueryData(queryKey, data);
                queryClient.invalidateQueries(queryKey);
            }
        });
    }, [
        queryClient,
        query
    ].concat(_toConsumableArray(typeof queryKey === "string" ? [
        queryKey
    ] : queryKey)));
};
export var useMutationSuccessHandler = function(options) {
    var queriesToInvalidate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var queryClient = useQueryClient();
    return function(data, variables, context) {
        var ref;
        queriesToInvalidate.forEach(function(key) {
            queryClient.invalidateQueries(key);
        });
        options === null || options === void 0 ? void 0 : (ref = options.onSuccess) === null || ref === void 0 ? void 0 : ref.call(options, data, variables, context);
    };
};
export var expiringQueryOptions = function(param) {
    var hrs = param.hrs;
    return {
        staleTime: hrs * 60 * 60 * 1000,
        cacheTime: 0,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    };
};
